<template>
  <div style="margin-top:15px;">
    <b>
      {{ roomName(value.type) }}
    </b>
    {{ summary }}
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'

export default {
  name: 'SpecialRoomSummary',

  data: () => {
    return {
      features: [],
      summary: '',
      dataFeatures: []
    }
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    linkOptions: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    ...sharedComputed
  },

  created () {
    this.features = this.$store.getters['moduleListLinkItems']['objects'].features
    this.summary = this.value && this.value.features
      ? Object.keys(this.value.features).filter((featureId) => {
          return this.value.features[featureId].checked
        }).map((featureId) => {
          let quantity = this.value.features[featureId].quantity || 1
          if (quantity > 1) {
            return quantity + ' x ' + this.featureName(featureId)
          }
          return this.featureName(featureId)
        }).join(', ')
      : ''
  },

  methods: {
    ...sharedMethods,

    roomName (type) {
      let roomName = ''
      if (this.linkOptions && this.linkOptions.type) {
        this.linkOptions.type.forEach((roomType) => {
          if (roomType.value === type) {
            roomName = roomType.text
          }
        })
      }
      return roomName
    },

    featureName (id) {
      let featureName = ''
      if (this.features) {
        this.features.forEach((feature) => {
          if (feature._id === id) {
            featureName = feature['name_' + this.language] || feature.name_en
          }
        })
      }
      return featureName
    }
  }
}
</script>
